import React, { FC } from 'react';
import { Route, Redirect } from 'react-router-dom';

interface Props {
  exact?: boolean;
  path: string;
  comp: React.ElementType;
  condition: boolean;
  [x: string]: any;
}

export const ProtectedRoutes: FC<Props> = (props) => {
  const { comp: Component, condition } = props;

  return <Route {...props} render={(props: Props) => (condition ? <Component {...props} /> : <Redirect to="/login" />)} />;
};

export default ProtectedRoutes;
